<template>
  <Loader
    v-if="showLoader"
    :display-loader="true"
    message="Initializing application..."
  />

  <div v-else-if="initFailed" class="error-message">
    <p>Failed to initialize authentication. Please try again later.</p>
  </div>

  <slot v-else></slot>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { storeToRefs } from "pinia";
import Loader from "./Loader.vue";

const authStore = useAuthStore();
const { initialized } = storeToRefs(authStore);
const authInitRequested = ref(false);
const initFailed = ref(false);

const showLoader = computed(() => {
  return !initialized.value && authInitRequested.value && !initFailed.value;
});
</script>

<style scoped>
.error-message {
  text-align: center;
  padding: 2rem;
  color: red;
}
</style>
